import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M8.5 11.43l-7.5-4V7c0-.55.45-1 1-1h12.18c-.11-.31-.18-.65-.18-1H2C.9 5 0 5.9 0 7v8c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V8c-.51 0-.98-.14-1.4-.36l-7.1 3.79zM16 15c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1V8.57l7.26 3.87c.07.04.15.06.24.06s.16-.02.24-.06L16 8.57V15z',
    'M17 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z',
  ],
  height: 20,
  width: 20,
});
